/* One-Day Stand – Classics im Abo (sections/ods-classics-abo.liquid). Stand 09.10.2026.
   Rechnet mit den Live-Daten aus dem JSON-Block der Section (Preise in Cent, Währung des Markts).
   Schreibt nur Zahlen und kurze Texte in Elemente mit .notranslate. Diese Texte stehen hier auf Deutsch und Englisch (Weglot). */
(function () {
  'use strict';

  var T = {
    de: {
      size: { 250: '250 g', 1000: '1 kg', 3000: '3 kg' },
      grind: { bean: 'ganze Bohne', em: 'Espressomaschine', bl: 'Bialetti' },
      every: function (w) { return 'alle ' + w + ' Wochen'; },
      perKg: function (x) { return x + ' pro kg'; },
      extra: function (x) { return '+ ' + x; },
      calc: function (g, d) { return 'Ihr braucht rund ' + g + ' g pro Woche. Ein Kilo reicht euch etwa ' + d + ' Tage.'; },
      rec: function (t) { return 'Passt am besten: ' + t; },
      hintMore: 'Das ist mehr, als ihr trinkt. Wenn sich Kaffee stapelt, überspringst du im Kundenkonto einfach eine Lieferung.',
      hintLess: 'Damit wird es knapp: Ihr trinkt mehr, als in diesem Rhythmus ankommt.',
      pct: function (p) { return '−' + p + ' %'; },
      noDisc: 'kein Abo-Rabatt',
      perKgParen: function (x) { return '(' + x + ' / kg)'; },
      shipFree: 'Versand in Deutschland: kostenlos',
      shipCost: function (x, f) { return 'zzgl. ' + x + ' Versand in Deutschland (kostenlos ab ' + f + ')'; },
      shipAbroad: 'Versand: siehe Checkout',
      save: function (x, y) { return 'Du sparst ' + x + ' pro Lieferung gegenüber dem Einzelkauf, Versand eingerechnet. Bei gleicher Menge sind das rund ' + y + ' im Jahr.'; },
      saveNoShip: function (x, y) { return 'Du sparst ' + x + ' pro Lieferung gegenüber dem Einzelkauf. Bei gleicher Menge sind das rund ' + y + ' im Jahr.'; },
      even: 'Gleicher Preis wie im Einzelkauf. Dafür musst du nie wieder dran denken.',
      perDel: 'pro Lieferung',
      gift: function (n) { return 'Verschenk ' + n + ' für 6 oder 12 Monate. Du zahlst einmal, wir liefern jeden Monat, in Deutschland ohne Versandkosten.'; },
      g6: function (x) { return '6 Monate · ab ' + x; },
      g12: function (x) { return '12 Monate · ab ' + x; },
      finale: function (n) { return 'Du und ' + n + '. Fehlt nur noch dein Ja.'; },
      adding: 'Kommt in den Warenkorb …',
      failed: 'Hat nicht geklappt. Wir öffnen die Produktseite.',
      soldout: 'Gerade ausverkauft'
    },
    en: {
      size: { 250: '250 g', 1000: '1 kg', 3000: '3 kg' },
      grind: { bean: 'whole bean', em: 'espresso machine', bl: 'moka pot' },
      every: function (w) { return 'every ' + w + ' weeks'; },
      perKg: function (x) { return x + ' per kg'; },
      extra: function (x) { return '+ ' + x; },
      calc: function (g, d) { return 'You need about ' + g + ' g a week. A kilo lasts you about ' + d + ' days.'; },
      rec: function (t) { return 'Best fit: ' + t; },
      hintMore: 'That’s more than you drink. If coffee starts piling up, just skip a delivery in your account.',
      hintLess: 'That’s cutting it fine: you drink more than arrives at this rhythm.',
      pct: function (p) { return '−' + p + '%'; },
      noDisc: 'no subscription discount',
      perKgParen: function (x) { return '(' + x + ' / kg)'; },
      shipFree: 'Shipping within Germany: free',
      shipCost: function (x, f) { return 'plus ' + x + ' shipping within Germany (free from ' + f + ')'; },
      shipAbroad: 'Shipping: calculated at checkout',
      save: function (x, y) { return 'You save ' + x + ' per delivery compared with a one-off purchase, shipping included. For the same amount, that’s about ' + y + ' a year.'; },
      saveNoShip: function (x, y) { return 'You save ' + x + ' per delivery compared with a one-off purchase. For the same amount, that’s about ' + y + ' a year.'; },
      even: 'Same price as a one-off purchase. But you never have to think about it again.',
      perDel: 'per delivery',
      gift: function (n) { return 'Give ' + n + ' for 6 or 12 months. You pay once, we deliver every month, with free shipping within Germany.'; },
      g6: function (x) { return '6 months · from ' + x; },
      g12: function (x) { return '12 months · from ' + x; },
      finale: function (n) { return 'You and ' + n + '. All that’s missing is your yes.'; },
      adding: 'Adding to basket …',
      failed: 'That didn’t work. Opening the product page.',
      soldout: 'Currently sold out'
    }
  };

  /* Richtwerte Pulver pro Tasse im Vollautomaten (Quellen im Projekt-Doc) */
  var G_PER_CUP = { mild: 7, normal: 9, strong: 12 };
  var GRINDS = ['bean', 'em', 'bl'];

  function sizeOf(o) {
    var m = /(\d+(?:[.,]\d+)?)\s*(kg|g)\b/i.exec(String(o || ''));
    if (!m) return 0;
    var n = parseFloat(m[1].replace(',', '.'));
    return /kg/i.test(m[2]) ? Math.round(n * 1000) : Math.round(n);
  }
  function grindOf(o) {
    o = String(o || '').toLowerCase();
    if (/ganze|bohne|bean/.test(o)) return 'bean';
    if (/bialetti|moka/.test(o)) return 'bl';
    if (/maschine|siebtr|espresso/.test(o)) return 'em';
    return '';
  }
  function prep(c) {
    var main = {}, abo = {}, plans = {};
    function put(map, v) {
      var s = sizeOf(v.o1), g = grindOf(v.o2);
      if (s && g && !map[s + '|' + g]) map[s + '|' + g] = v;
    }
    (c.main || []).forEach(function (v) { put(main, v); });
    (c.abo || []).forEach(function (v) { put(abo, v); });
    (c.plans || []).forEach(function (p) {
      var m = /(\d+)\s*-?\s*(week|woche)/i.exec(p.n || '');
      if (m && !plans[+m[1]]) plans[+m[1]] = String(p.id);
    });
    c.M = main; c.A = abo; c.P = plans;
    return c;
  }

  function init(root) {
    if (!root || root.getAttribute('data-ods-init')) return;
    var dataEl = root.querySelector('[data-ods-data]');
    if (!dataEl) return;
    var D;
    try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var C = (D.coffees || []).map(prep).filter(function (c) { return Object.keys(c.A).length && Object.keys(c.P).length; });
    if (!C.length) return;
    root.setAttribute('data-ods-init', '1');

    var path = location.pathname;
    var EN = /^en/i.test(document.documentElement.getAttribute('lang') || '') || /^\/en(\/|$)/.test(path);
    var L = T[EN ? 'en' : 'de'];
    var LOC = EN ? 'en-GB' : 'de-DE';
    var PFX = /^\/en(\/|$)/.test(path) ? '/en' : '';
    var CUR = D.cur || 'EUR';
    var S = D.ship || { light: 390, heavy: 490, from: 4000, lightMax: 600 };
    var SHIPDE = (!D.country || D.country === 'DE') && CUR === 'EUR';
    var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var fmt = null, fmt0 = null;
    try {
      fmt = new Intl.NumberFormat(LOC, { style: 'currency', currency: CUR });
      fmt0 = new Intl.NumberFormat(LOC, { style: 'currency', currency: CUR, minimumFractionDigits: 0, maximumFractionDigits: 0 });
    } catch (e) {}
    function money(c) { return fmt ? fmt.format(c / 100) : (c / 100).toFixed(2) + ' ' + CUR; }
    function money0(c) { return fmt0 ? fmt0.format(Math.round(c / 100)) : Math.round(c / 100) + ' ' + CUR; }
    function num(n) { return Number(n).toLocaleString(LOC); }

    function q(s) { return root.querySelector(s); }
    function qa(s) { return Array.prototype.slice.call(root.querySelectorAll(s)); }
    function o(n) { return root.querySelector('[data-o="' + n + '"]'); }
    function txt(el, s) { if (el) el.textContent = s; }

    /* Mobile Leiste an body hängen, damit position:fixed nicht an Theme-Containern hängt */
    var dock = o('dock');
    if (dock) {
      Array.prototype.forEach.call(document.querySelectorAll('body > .ods-dock'), function (el) { if (el !== dock) el.parentNode.removeChild(el); });
      if (dock.parentNode !== document.body) document.body.appendChild(dock);
    }
    function d(n) { return dock ? dock.querySelector('[data-o="' + n + '"]') : null; }

    /* Kartenpreise einheitlich im Format des Scripts */
    qa('[data-cents]').forEach(function (el) { el.textContent = money(+el.getAttribute('data-cents')); });

    function byKey(k) { for (var i = 0; i < C.length; i++) { if (C[i].key === k) return C[i]; } return null; }
    function sizes(c) {
      var out = [];
      Object.keys(c.A).forEach(function (k) { var n = +k.split('|')[0]; if (out.indexOf(n) < 0) out.push(n); });
      return out.sort(function (a, b) { return a - b; });
    }
    function grinds(c, size) { return GRINDS.filter(function (g) { return !!c.A[size + '|' + g]; }); }
    function weeksOf(c) { return Object.keys(c.P).map(Number).sort(function (a, b) { return a - b; }); }
    function aboUnit(c, key, w) {
      var v = c.A[key];
      if (!v) return 0;
      var pl = c.P[w] || c.P[weeksOf(c)[0]];
      return (pl && v.sp && v.sp[pl] != null) ? v.sp[pl] : v.p;
    }
    /* Versand Deutschland: Abo frei, wenn der Kaffee so markiert ist; sonst ab Freigrenze frei, darunter nach Gewicht */
    function ship(total, grams, isAbo, c) {
      if (!SHIPDE) return null;
      if (isAbo && c.free) return 0;
      if (total >= S.from) return 0;
      return grams <= S.lightMax ? S.light : S.heavy;
    }

    var st = { key: C[0].key, cups: 4, strength: 'normal', size: 1000, qty: 1, grind: 'bean', weeks: 4, manual: false };
    (function preselect() {
      var p = '';
      try { p = (new URLSearchParams(location.search).get('match') || '').toLowerCase(); } catch (e) {}
      if (!p) p = (location.hash || '').replace('#', '').toLowerCase();
      if (!p) { var ch = q('input[data-o="coffee"]:checked'); if (ch) p = ch.value; }
      if (!p) return;
      for (var i = 0; i < C.length; i++) {
        if (C[i].key === p || C[i].key.indexOf(p) === 0) { st.key = C[i].key; return; }
      }
    })();
    function cur() { return byKey(st.key) || C[0]; }

    /* Vorschlag: kleinster Überschuss, höchstens 5 % zu wenig; bei Gleichstand weniger Tüten, längerer Rhythmus, größere Tüte */
    function recommend(c) {
      var need = st.cups * G_PER_CUP[st.strength], best = null, ws = weeksOf(c);
      sizes(c).forEach(function (sz) {
        [1, 2].forEach(function (n) {
          ws.forEach(function (w) {
            var r = (sz * n) / (w * 7) / need - 1;
            if (r < -0.05) return;
            var better = !best || r < best.r - 1e-9 ||
              (Math.abs(r - best.r) < 1e-9 && (n < best.qty || (n === best.qty && (w > best.weeks || (w === best.weeks && sz > best.size)))));
            if (better) best = { size: sz, qty: n, weeks: w, r: r };
          });
        });
      });
      if (!best) {
        var ss = sizes(c), mx = ss[ss.length - 1], w0 = ws[0] || 2;
        best = { size: mx, qty: 2, weeks: w0, r: (mx * 2) / (w0 * 7) / need - 1 };
      }
      best.need = need;
      return best;
    }
    function validate() {
      var c = cur(), ss = sizes(c), ws = weeksOf(c);
      if (ss.indexOf(st.size) < 0) st.size = ss.indexOf(1000) >= 0 ? 1000 : ss[0];
      var gs = grinds(c, st.size);
      if (gs.indexOf(st.grind) < 0) st.grind = gs.indexOf('bean') >= 0 ? 'bean' : gs[0];
      if (ws.indexOf(st.weeks) < 0) st.weeks = ws.indexOf(4) >= 0 ? 4 : ws[ws.length - 1];
    }
    function applyRec() {
      var r = recommend(cur());
      st.size = r.size; st.qty = r.qty; st.weeks = r.weeks; st.manual = false;
      validate();
    }

    function quote() {
      var c = cur(), key = st.size + '|' + st.grind, av = c.A[key], mv = c.M[key];
      var plan = c.P[st.weeks] || null;
      var unit = aboUnit(c, key, st.weeks), total = unit * st.qty, grams = st.size * st.qty;
      var singleUnit = mv ? mv.p : av.p, single = singleUnit * st.qty;
      var pct = singleUnit > 0 ? Math.round((1 - unit / singleUnit) * 100) : 0;
      var shipAbo = ship(total, grams, true, c), shipSingle = ship(single, grams, false, c);
      var save = SHIPDE ? (single + shipSingle) - (total + shipAbo) : single - total;
      return {
        c: c, av: av, mv: mv, plan: plan, unit: unit, total: total, single: single, pct: pct,
        shipAbo: shipAbo, save: save, saveYear: save * 52 / st.weeks, perKg: Math.round(unit * 1000 / st.size),
        href: PFX + c.aboUrl + '?variant=' + av.id + (plan ? '&selling_plan=' + plan : ''),
        once: PFX + c.mainUrl + (mv ? '?variant=' + mv.id : '')
      };
    }

    function setImg(box, src, alt) {
      if (!box || !src) return;
      var img = box.querySelector('img');
      if (!img) { img = document.createElement('img'); img.loading = 'lazy'; img.alt = ''; box.appendChild(img); }
      if (img.getAttribute('src') !== src) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = src; }
      if (alt != null) img.alt = alt;
    }
    function check(name, val) {
      qa('input[data-o="' + name + '"]').forEach(function (i) { i.checked = String(i.value) === String(val); });
    }
    function line() {
      return (st.qty > 1 ? st.qty + ' × ' : '') + L.size[st.size] + ' · ' + L.grind[st.grind] + ' · ' + L.every(st.weeks);
    }
    function recText(r) { return (r.qty > 1 ? r.qty + ' × ' : '') + (L.size[r.size] || r.size + ' g') + ' ' + L.every(r.weeks); }

    function render() {
      validate();
      var c = cur(), x = quote(), rec = recommend(c);

      /* Karten und Profil */
      qa('.ods-match').forEach(function (card) { card.classList.toggle('is-on', card.getAttribute('data-key') === c.key); });
      check('coffee', c.key);
      qa('.ods-profile').forEach(function (p) { p.hidden = p.getAttribute('data-key') !== c.key; });

      /* Rechner */
      txt(o('cups'), st.cups);
      o('cups-minus').disabled = st.cups <= 1;
      o('cups-plus').disabled = st.cups >= 12;
      check('str', st.strength);
      var perWeek = Math.round(rec.need * 7 / 10) * 10, days = Math.floor(1000 / rec.need);
      txt(o('calc-out'), L.calc(num(perWeek), days));
      txt(o('calc-rec'), L.rec(recText(rec)));
      o('apply').hidden = !(rec.size !== st.size || rec.qty !== st.qty || rec.weeks !== st.weeks);
      var r = ((st.size * st.qty) / (st.weeks * 7)) / rec.need - 1, hint = '';
      if (r > 0.35) hint = L.hintMore; else if (r < -0.1) hint = L.hintLess;
      txt(o('hint'), hint); o('hint').hidden = !hint;

      /* Menge */
      var ss = sizes(c);
      qa('[data-size]').forEach(function (lab) {
        var sz = +lab.getAttribute('data-size'), ok = ss.indexOf(sz) >= 0;
        lab.hidden = !ok;
        if (ok) txt(lab.querySelector('[data-o="perkg"]'), L.perKg(money(Math.round(aboUnit(c, sz + '|bean', st.weeks) * 1000 / sz))));
      });
      check('size', st.size);
      txt(o('qty'), st.qty);
      o('qty-minus').disabled = st.qty <= 1;
      o('qty-plus').disabled = st.qty >= 4;

      /* Mahlung */
      var gs = grinds(c, st.size), base = aboUnit(c, st.size + '|bean', st.weeks);
      qa('[data-grind]').forEach(function (lab) {
        var g = lab.getAttribute('data-grind'), ok = gs.indexOf(g) >= 0;
        lab.hidden = !ok;
        var ex = lab.querySelector('[data-o="gextra"]');
        if (ok && ex) { var diff = aboUnit(c, st.size + '|' + g, st.weeks) - base; txt(ex, diff > 0 ? L.extra(money(diff)) : ' '); }
      });
      check('grind', st.grind);
      var note = gs.length > 1 ? 'multi' : (st.size === 1000 || st.size === 3000 ? String(st.size) : 'other');
      qa('[data-gnote]').forEach(function (p) { p.hidden = p.getAttribute('data-gnote') !== note; });

      /* Rhythmus */
      var ws = weeksOf(c);
      qa('[data-weeks]').forEach(function (lab) { lab.hidden = ws.indexOf(+lab.getAttribute('data-weeks')) < 0; });
      check('weeks', st.weeks);

      /* Ticket */
      setImg(o('t-bag'), c.img, '');
      txt(o('t-name'), c.name);
      txt(o('t-line'), line());
      txt(o('t-price'), money(x.total));
      var was = o('t-was');
      was.textContent = '';
      if (x.pct > 0) {
        var s = document.createElement('s'); s.textContent = money(x.single); was.appendChild(s);
        var tg = document.createElement('span'); tg.className = 'ods-tag'; tg.textContent = L.pct(x.pct); was.appendChild(tg);
      } else {
        var tp = document.createElement('span'); tp.className = 'ods-tag ods-tag--plain'; tp.textContent = L.noDisc; was.appendChild(tp);
      }
      var pk = document.createElement('span'); pk.textContent = L.perKgParen(money(x.perKg)); was.appendChild(pk);
      txt(o('t-ship'), x.shipAbo == null ? L.shipAbroad : (x.shipAbo === 0 ? L.shipFree : L.shipCost(money(x.shipAbo), money0(S.from))));
      var sv = o('t-save');
      if (x.save > 0) {
        sv.className = 'ods-save notranslate';
        sv.textContent = (SHIPDE ? L.save : L.saveNoShip)(money(x.save), money0(x.saveYear));
      } else {
        sv.className = 'ods-save ods-save--even notranslate';
        sv.textContent = L.even;
      }
      var ok = !!(x.av && x.av.a);
      [o('cta'), d('d-cta')].forEach(function (b) {
        if (!b) return;
        b.href = x.href;
        if (ok) b.removeAttribute('aria-disabled'); else b.setAttribute('aria-disabled', 'true');
      });
      txt(o('cta-label'), ok ? 'Make it official' : L.soldout);
      var once = o('once'); if (once) once.href = x.once;
      o('err').hidden = true;

      /* Mobile Leiste */
      setImg(d('d-bag'), c.img, '');
      txt(d('d-price'), money(x.total));
      txt(d('d-line'), L.perDel + ' · ' + c.name + ' · ' + line());

      /* Verkuppeln */
      var gift = o('gift'), g6 = c.g6, g12 = c.g12;
      if (gift) gift.hidden = !g6 && !g12;
      txt(o('gift-txt'), L.gift(c.name));
      [['g6', g6, L.g6], ['g12', g12, L.g12]].forEach(function (a) {
        var el = o(a[0]);
        if (!el) return;
        el.hidden = !a[1];
        if (a[1]) { el.textContent = a[2](money(a[1].from)); el.href = PFX + a[1].url + '?variant=' + a[1].v + (a[1].plan ? '&selling_plan=' + a[1].plan : ''); }
      });
      txt(o('finale'), L.finale(c.name));
    }

    function burst(card) {
      if (reduce) return;
      for (var i = 0; i < 5; i++) {
        var h = document.createElement('span');
        h.className = 'ods-burst';
        h.setAttribute('aria-hidden', 'true');
        h.innerHTML = '<svg viewBox="0 0 24 24" focusable="false"><use href="#ods-i-heart"/></svg>';
        h.style.setProperty('--dx', (Math.random() * 120 - 60).toFixed(0) + 'px');
        h.style.setProperty('--rot', (Math.random() * 50 - 25).toFixed(0) + 'deg');
        h.style.animationDelay = (i * 60) + 'ms';
        h.addEventListener('animationend', function () { if (this.parentNode) this.parentNode.removeChild(this); });
        card.appendChild(h);
      }
    }

    /* Warenkorb: Abo mit Plan direkt hinzufügen, sonst Produktseite mit Variante und Plan */
    function addToCart(e) {
      var x = quote();
      if (!x.av || !x.av.a || !x.plan || !window.fetch) return;
      e.preventDefault();
      var btns = [o('cta'), d('d-cta')], label = o('cta-label'), dl = d('d-cta');
      var dlText = dl ? dl.textContent : '';
      btns.forEach(function (b) { if (b) b.setAttribute('aria-disabled', 'true'); });
      txt(label, L.adding); if (dl) dl.textContent = L.adding;
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: x.av.id, quantity: st.qty, selling_plan: +x.plan }] })
      }).then(function (res) {
        if (!res.ok) throw new Error(String(res.status));
        return res.json();
      }).then(function () {
        location.href = PFX + '/cart';
      }).catch(function () {
        btns.forEach(function (b) { if (b) b.removeAttribute('aria-disabled'); });
        txt(label, 'Make it official'); if (dl) dl.textContent = dlText;
        var err = o('err'); txt(err, L.failed); err.hidden = false;
        setTimeout(function () { location.href = x.href; }, 1400);
      });
    }

    /* Ereignisse */
    root.addEventListener('change', function (e) {
      var t = e.target, k = t && t.getAttribute('data-o');
      if (!k) return;
      if (k === 'coffee') {
        st.key = t.value;
        if (!st.manual) applyRec(); else validate();
        render();
        var card = t.closest('.ods-match');
        if (card) { card.classList.remove('is-new'); void card.offsetWidth; card.classList.add('is-new'); burst(card); }
      } else if (k === 'str') { st.strength = t.value; applyRec(); render(); }
      else if (k === 'size') { st.size = +t.value; st.manual = true; render(); }
      else if (k === 'grind') { st.grind = t.value; render(); }
      else if (k === 'weeks') { st.weeks = +t.value; st.manual = true; render(); }
    });
    function onClick(name, fn) { var el = o(name); if (el) el.addEventListener('click', fn); }
    onClick('cups-minus', function () { st.cups = Math.max(1, st.cups - 1); applyRec(); render(); });
    onClick('cups-plus', function () { st.cups = Math.min(12, st.cups + 1); applyRec(); render(); });
    onClick('apply', function () { applyRec(); render(); });
    onClick('qty-minus', function () { st.qty = Math.max(1, st.qty - 1); st.manual = true; render(); });
    onClick('qty-plus', function () { st.qty = Math.min(4, st.qty + 1); st.manual = true; render(); });
    onClick('cta', addToCart);
    var dcta = d('d-cta'); if (dcta) dcta.addEventListener('click', addToCart);

    /* Mobile Leiste: sichtbar im Konfigurator, solange das Ticket nicht im Bild ist */
    var cfg = o('config'), tk = o('ticket');
    if (dock && cfg && tk && 'IntersectionObserver' in window) {
      var inCfg = false, seen = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.target === cfg) inCfg = en.isIntersecting;
          if (en.target === tk) seen = en.isIntersecting;
        });
        dock.hidden = !(inCfg && !seen);
      }, { threshold: 0.05 });
      io.observe(cfg); io.observe(tk);
    }

    applyRec();
    render();
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-ods]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
